/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { useLanguage } from '../contexts/LanguageContext';
import { normalizeExampleVars } from '../lib/calcExamples';

/**
 * The CMS-managed ERE market price (how_it_works.example_vars.ere_price_eur) —
 * the same admin-editable value that drives the Kennisbank benchmark ticker and
 * rekenvoorbeelden. This is the LEADING price figure for every earnings
 * estimate; the ERE_PRICE constant in lib/earnings.ts is only the fallback when
 * the CMS key is absent (normalizeExampleVars supplies the code default).
 */
export function useErePrice(): number {
  const { t } = useLanguage();
  return normalizeExampleVars(t('how_it_works.example_vars', { returnObjects: true }))
    .ere_price_eur;
}
